<div class="w-full">
    <input [type]="type" name="" id="" [value]="_value" [placeholder]="placeholder" (input)="onInputChange($event)" (blur)="touch()" class="form-input">
</div> 


